import React, { useEffect, useState } from 'react';

const Loading = () => {
  const ballStyle = ' w-2 aspect-square bg-white rounded-full';
  const animateStyle = 'animate-loading';

  const [secondBall, setSecondBall] = useState(false);
  const [thirdBall, setThirdBall] = useState(false);

  useEffect(() => {
    const timeoutOne = setTimeout(() => setSecondBall(true), 200);
    const timeoutTwo = setTimeout(() => setThirdBall(true), 400);

    return () => {
      clearTimeout(timeoutOne);
      clearTimeout(timeoutTwo);
    };
  }, []);

  return (
    <div className="flex gap-2">
      <div className={`${ballStyle} ${animateStyle}`} />
      <div className={`${ballStyle} ${secondBall ? animateStyle : ''}`} />
      <div className={`${ballStyle} ${thirdBall ? animateStyle : ''}`} />
    </div>
  );
};

export default Loading;
